//#region IMPORT
import React from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
/** Icons Import */

import dayjs from 'dayjs';
import { PropTypes } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import POL_BASIC_02F from './../POL_BASIC_02/POL_BASIC_02F';
import POL_BASIC_01F from './../POL_BASIC_01/POL_BASIC_01F';
import { AuthButton } from '../../../../Components/MUIs';
import { setYear } from '../../../../Reducer/SearchReducer';
//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <React.Fragment>
      {value === index && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: 0, // ✅ flex container 하에서 overflow 계산 가능하게 함
          }}
        >
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function POL_BASIC(props) {
  //#region 변수
  // const gridRef7 = useRef(); // 안전보건총괄책임자(도급)
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);
  const userInfo = useSelector((state) => state.BaseInfo.userInfo);

  //#endregion
  //#region 웹

  //#endregion
  //#region 함수

  //#endregion
  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="PolicyAndGoals"
          searchYn="Y"
          addYn="Y"
          saveYn="Y"
          deleteYn="Y"
          // fileYn={props.value === 0 ? 'N' : 'Y'} // 2025-07-22 미리보기 이슈로 잠시 주석 (N처리)
          fileYn="N"
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              searchInfo.searchText = e;
              props.setFilterClick1(true);
            } else if (props.value === 1) {
              searchInfo.searchText = e;
              props.setFilterClick2(true);
            } else if (props.value === 2) {
              props.setFilterClick3(true);
            }
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setSaveClick1(true);
            } else if (props.value === 1) {
              props.setSaveClick2(true);
            } else if (props.value === 2) {
              props.setSaveClick3(true);
            }
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setPrintClick1(true);
            } else if (props.value === 1) {
              props.setPrintClick2(true);
            } else if (props.value === 2) {
              props.setPrintClick3(true);
            } else if (props.value === 3) {
              props.setPrintClick4(true);
            }
          }}
          deletePayload1={props.deletePayload1}
          searchPayload1={props.searchPayload1}
          savePayload1={props.savePayload1}
          saveFilePath1={`Business/${searchInfo.custCd}/POL_FILE`}
          conditions={
            props.value === 0
              ? [
                  ...(userInfo.authCd === 'ADMIN'
                    ? [
                        {
                          type: 'combo',
                          name: '회사',
                          items: searchInfo.coList,
                          value: searchInfo.coCd,
                          onChange: (e) => {
                            props.handleCoChange(e);
                            props.setSearchClick1(true);
                          },
                        },
                      ]
                    : []),
                ]
              : props.value === 1
                ? [
                    {
                      type: 'datePicker',
                      views: ['year'],
                      openTo: 'year',
                      title: '기간',
                      name: '조회연도',
                      value: searchInfo.year
                        ? dayjs(searchInfo.year)
                        : dayjs(),
                      onChange: (date) => {
                        if (date) {
                          const changeYear = dayjs(date).format('YYYY');
                          dispatch(setYear(changeYear));
                          props.setSearchClick2(true);
                        }
                      },
                      currentLocale: 'ko',
                      format: 'YYYY',
                    },
                    ...(userInfo.authCd === 'ADMIN'
                      ? [
                          {
                            type: 'combo',
                            name: '회사',
                            items: searchInfo.coList,
                            value: searchInfo.coCd,
                            onChange: (e) => {
                              props.handleCoChange(e);
                              props.setSearchClick2(true);
                            },
                          },
                        ]
                      : []),
                    {
                      type: 'combo',
                      name: '사업장',
                      items: searchInfo.custList,
                      value: searchInfo.custCd,
                      onChange: (e) => {
                        props.handleCustChange(e);
                        props.setSearchClick2(true);
                      },
                    },
                  ]
                : []
          }
          grids={
            <React.Fragment>
              <Box sx={{ mb: 1 }}>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="안전보건경영방침"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="안전보건목표 및 추진계획"
                    {...A11yProps(1)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  {/* <Tab
                    label="추진결과"
                    {...A11yProps(2)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  /> */}
                </Tabs>
              </Box>
              <CustomTabPanel value={props.value} index={0}>
                <POL_BASIC_01F
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  copyClick1={props.copyClick1}
                  setCopyClick1={props.setCopyClick1}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <POL_BASIC_02F
                  filterClick2={props.filterClick2}
                  setFilterClick2={props.setFilterClick2}
                  searchClick2={props.searchClick2}
                  setSearchClick2={props.setSearchClick2}
                  addClick2={props.addClick2}
                  setAddClick2={props.setAddClick2}
                  saveClick2={props.saveClick2}
                  setSaveClick2={props.setSaveClick2}
                  deleteClick2={props.deleteClick2}
                  setDeleteClick2={props.setDeleteClick2}
                  printClick2={props.printClick2}
                  setPrintClick2={props.setPrintClick2}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={3}></CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default POL_BASIC;
